export const ja_JP = {
  '返回': '戻る',
  '功放控制': 'アンプ制御',
  '功放控制（已缩放适配一屏）': 'アンプ制御（画面に合わせてスケール）',
  '连接状态': '接続状態',
  'MCU连接状态': 'MCU状態',
  'Hamlib: Connected': 'Hamlib: Connected',
  'MUC: 未连接': 'MUC: 未接続',
  'Connected': '接続済み',
  'Disconnected': '未接続',
  '输出天线：': '出力アンテナ: ',
  '手动选择': '手動',
  '自动选择': '自動',
  '触发模式：': 'トリガーモード: ',
  '接收状态': '受信',
  'PPT1': 'PPT1',
  'PPT2': 'PPT2',
  '输入功率触发': '入力電力',
  '时间': '時間',
  '系统同步': 'システム同期',
  '报警信息': 'アラーム',
  '设备报警': '機器アラーム',
  '点击查看详情': 'クリックして詳細を表示',
  '清除报警': 'アラーム解除',
  '清除报警指令已发送': 'アラーム解除コマンドを送信しました',
  '清除报警发送失败': 'アラーム解除の送信に失敗しました',
  '密码验证': '密码验证',
  '请输入密码': '请输入密码',
  '提示：密码为 666': '提示：密码为 666',
  '密码验证成功': '密码验证成功',
  '密码错误，请重试': '密码错误，请重试',
  '工程参数设置已保存': '工程参数设置已保存',
  '工程参数设置': '工程参数设置',
  '审计日志': '审计日志',
  '报警日志': '报警日志',
  'MCU日志': 'MCU日志',
  '更新审计日志指令已发送': '更新审计日志指令已发送',
  '更新报警日志指令已发送': '更新报警日志指令已发送',
  '更新MCU日志指令已发送': '更新MCU日志指令已发送',
  '更新审计日志发送失败': '更新审计日志发送失败',
  '更新报警日志发送失败': '更新报警日志发送失败',
  '更新MCU日志发送失败': '更新MCU日志发送失败',
  '启用报警信息': '启用报警信息',
  '按日志类型与精确时间范围查询设备事件': '按日志类型与精确时间范围查询设备事件',
  '共 {count} 条': '共 {count} 条',
  '开始时间': '开始时间',
  '结束时间': '结束时间',
  '选择开始时间': '选择开始时间',
  '选择结束时间': '选择结束时间',
  '数量': '数量',
  '等级': '等级',
  '消息': '消息',
  '更新': '更新',
  '确认': '確認',
  '取消': 'キャンセル',
  '确定': 'OK',
  '已连接': '已连接',
  '未连接': '未连接',
  '输入天线1': '入力アンテナ1',
  '输入天线2': '入力アンテナ2',
  '输入天线衰减器': '入力減衰器',
  '输入衰减器': '入力減衰器',
  '功放': 'アンプ',
  '天调': 'チューナー',
  '关闭': 'オフ',
  '开启': 'オン',
  '调谐中': 'チューニング中',
  '调谐失败': 'チューニング失敗',
  '输出天线1': '出力アンテナ1',
  '输出天线2': '出力アンテナ2',
  '输出天线3': '出力アンテナ3',
  '输出天线4': '出力アンテナ4',
  '假负载': 'ダミー負荷',
  '频率范围无效': '频率范围无效',
  '天线配置保存失败': '天线配置保存失败',
  '频段未获取': '周波数未取得',
  'Counter': 'カウンター',
  'Hamlib': 'Hamlib',
  '滤波器：': 'フィルター: ',
  '频段：': 'バンド: ',
  '输入': '入力',
  '输出': '出力',
  '反向功率': '逆電力',
  '驻波': 'SWR',
  '电压:': '電圧:',
  '电流:': '電流:',
  '功率:': '電力:',
  '温度:': '温度:',
  '选择频段': 'バンド選択',
  '编辑频段': 'バンド編集',
  '波段电压': 'バンド電圧',
  '频段名称': '频段名称',
  '频段值': '频段值',
  '当前波段电压：': '当前波段电压：',
  '波段电压:': '波段电压:',
  '自动模式': '自動モード',
  '协议模式': 'プロトコルモード',
  '功放开启确认': '功放开启确认',
  '设备请求确认开启功放。': '设备请求确认开启功放。',
  '更新确认': '更新确认',
  '确认更新': '确认更新',
  '设备检测到可用更新，是否开始下载并安装？': '设备检测到可用更新，是否开始下载并安装？',
  '更新进度': '更新进度',
  '正在更新…': '正在更新…',
  '重启确认': '重启确认',
  '立即重启': '立即重启',
  '稍后重启': '稍后重启',
  '更新已安装完成，是否立即重启？': '更新已安装完成，是否立即重启？',
  '处理中…': '处理中…',
  '输入正向功率保护': '输入正向功率保护',
  '输入反向功率保护': '输入反向功率保护',
  '功放管输入过电压保护': '功放管输入过电压保护',
  '功放管输出过电压保护': '功放管输出过电压保护',
  '功放输出正向功率保护': '功放输出正向功率保护',
  '功放管输出反向功率保护': '功放管输出反向功率保护',
  '过流保护': '过流保护',
  '过压保护': '过压保护',
  '过温保护': '过温保护',
  '高驻波': '高驻波',
  '频率误差过大': '频率误差过大',
  '功放管输入过功率保护': '功放管输入过功率保护',
  '功放管输出过功率保护': '功放管输出过功率保护',
  '输出正向功率保护': '输出正向功率保护',
  '输出反向功率保护': '输出反向功率保护',
  '输入高驻波': '输入高驻波',
  '输出高驻波': '输出高驻波',
  '修改天线配置': '修改天线配置',
  '默认名称：{name}。名称留空并保存可恢复默认显示。频率单位为 Hz。': '默认名称：{name}。名称留空并保存可恢复默认显示。频率单位为 Hz。',
  '自定义名称': '自定义名称',
  '开始频率 (Hz)': '开始频率 (Hz)',
  '结束频率 (Hz)': '结束频率 (Hz)',
  '保存': '保存',
  '保存中…': '保存中…',
  '请输入有效的频率（Hz）': '请输入有效的频率（Hz）',
  '起始频率不能低于 {min} Hz': '起始频率不能低于 {min} Hz',
  '结束频率不能低于 {min} Hz': '结束频率不能低于 {min} Hz',
  '起始频率不能大于结束频率': '起始频率不能大于结束频率',
  '电台设置': '电台设置',
  '硬件菜单': '硬件菜单',
  '服务器设置': '服务器设置',
  '端口:': '端口:',
  '波特率:': '波特率:',
  '电台:': '电台:',
  '电台选择': '电台选择',
  '硬件版本:': '硬件版本:',
  '软件版本:': '软件版本:',
  '检查更新': '检查更新',
  '串口:': '串口:',
  '连接:': '连接:',
  '重新连接': '重新连接',
  '重启软件': '重启软件',
  '配置': '配置',
  'MQTT 配置': 'MQTT 配置',
  '串口选择': '串口选择',
  '波特率选择': '波特率选择',
  '共 {count} 个可用串口，点击切换 Hamlib 串口': '共 {count} 个可用串口，点击切换 Hamlib 串口',
  '共 {count} 个可选波特率，点击切换 Hamlib 波特率': '共 {count} 个可选波特率，点击切换 Hamlib 波特率',
  '共 {count} 个 Hamlib 机型': '共 {count} 个 Hamlib 机型',
  '请选择电台': '请选择电台',
  '设备 ID 无效，无法重启软件': '设备 ID 无效，无法重启软件',
  '重启软件指令已发送': '重启软件指令已发送',
  '重启软件指令发送失败': '重启软件指令发送失败',
  '可更新': '更新可能',
  '校准系数': '校准系数',
  '其他': '其他',
  '备份': '备份',
  '立即备份': '立即备份',
  '还原选中': '还原选中',
  '清除全部': '清除全部',
  '暂无备份': '暂无备份',
  '删除备份': '删除',
  '确认还原选中备份？': '确认还原选中备份？',
  '确认清除全部备份？': '确认清除全部备份？',
  '确认删除该备份？': '确认删除该备份？',
  '备份指令发送失败': '备份指令发送失败',
  '备份操作失败': '备份操作失败',
  '备份已创建': '备份已创建',
  '还原成功': '还原成功',
  '删除备份成功': '删除备份成功',
  '清除备份成功': '清除备份成功',
  '备份不可用': '备份不可用',
  '该备份校验失败，无法还原': '该备份校验失败，无法还原',
  '正在处理备份': '正在处理备份',
  '频段': '频段',
  '电压校准系数': '电压校准系数',
  '电流校准系数': '电流校准系数',
  '频率校准系数': '频率校准系数',
  'VGS校准系数': 'VGS校准系数',
  'DAC参考电压': 'DAC参考电压',
  '偏置电压': '偏置电压',
  '截止频率': '截止频率',
  '输入正向功率校准系数': '输入正向功率校准系数',
  '输入反向功率校准系数': '输入反向功率校准系数',
  '输出正向功率校准系数': '输出正向功率校准系数',
  '输出反向功率校准系数': '输出反向功率校准系数',
  '功放输入功率校准': '功放输入功率校准',
  '功放输出功率校准': '功放输出功率校准',
  '保护电压': '保护电压',
  '保护电流': '保护电流',
  '保护输入正向功率': '保护输入正向功率',
  '保护输入反向功率': '保护输入反向功率',
  '保护输出正向功率': '保护输出正向功率',
  '保护输出反向功率': '保护输出反向功率',
  '输入保护驻波比': '输入保护驻波比',
  '输出保护驻波比': '输出保护驻波比',
  '保护频率误差': '保护频率误差',
  '保护温度': '保护温度',
  '驻波调谐值': '驻波调谐值',
  'PTT触发电功率': 'PTT触发电功率',
  '恢复出厂设置': '恢复出厂设置',
  '功能待对接': '功能待对接',
  '天线切换失败': '天线切换失败',
  'Command send/receive log': 'Command send/receive log',
  '输入 <100W': '输入 <100W',
  '减少 {label}': '减少 {label}',
  '增加 {label}': '增加 {label}',
  '工程参数分页': '工程参数分页',
  '数据同步': '数据同步',
  '数据同步指令已发送': '数据同步指令已发送',
  '数据同步发送失败': '数据同步发送失败',
  '屏蔽': '屏蔽',
  '校准参数': '校准参数',
  '电压参数': '电压参数',
  '保存参数': '保存参数',
  '串口': 'シリアルポート',
  '波特率': 'ボーレート',
  '请选择串口': 'シリアルポートを選択',
  '请选择波特率': 'ボーレートを選択',
  '请选择rig': 'rigを選択',
  '频段校准系数': '帯域校正係数',
  'vgs:': 'vgs:',
  'vgs频率:': 'vgs周波数:',
  '电压': '電圧',
  '输出正向功率比较电压': '出力順方向電力比較電圧',
  '输出反向功率比较电压': '出力逆方向電力比較電圧',
  '输入反向功率比较电压': '入力逆方向電力比較電圧',
  '输入正向功率比较电压': '入力順方向電力比較電圧',
  '过流比较电压': '過電流比較電圧',
  '功率触发PTT电压': 'PTTトリガー電圧',
  '功放管输入功率比较电压': 'PA入力電力比較電圧',
  '功放管输出功率比较电压': 'PA出力電力比較電圧',
  '负载电阻': '負荷抵抗',
  '频率测量值': '周波数測定値',
  '天调电容选择值': 'アンテナチューナー容量選択値',
  '天调电感选择值': 'アンテナチューナーインダクタンス選択値',
  '保护驻波比': '保護SWR',
  '工程参数设置界面': '工程パラメータ設定画面',
} as const;
